
import corona2 from "./corona2.png"

export default function Header() {
    return (
        <div id="header">
             <div id="menu1" class="menu">CORONA</div>
        <img id="headCorona" alt="headerImg" src={corona2}></img>
          <div id="menu2" class="menu">UPDATES</div>
        </div>
    )
}
